"use strict";

/**
 * Clase `Tool` para centralizar métodos comunes en las demas clases.
 */
export class Tool {
    /**
     * Crea una instancia de la clase Tool.
     * @param {Object} httpError - Objeto para manejar errores HTTP.
     */
    constructor(httpError) {
        this.httpError = httpError;
    }

    /**
     * Verifica si existen todos los elementos en el DOM.
     * @param {string[]} selectors - Array de selectores.
     * @returns {boolean}
     */
    areElementsPresent(selectors) {
        return selectors.every((selector) =>
            document.body.contains(document.querySelector(selector))
        );
    }

    /**
     * Inicializa un Selectr de manera segura.
     * @param {HTMLElement} element
     */
    initSelectr(element) {
        try {
            new Selectr(element);
        } catch (error) {
            console.error("Error al inicializar Selectr:", error);
        }
    }

    /**
     * Hace una solicitud HTTP usando axios.
     * @param {string} method - Método HTTP.
     * @param {string} url - URL del endpoint.
     * @param {Object} data - Datos para enviar.
     * @returns {Promise}
     */
    async makeRequest(method, url, data) {
        try {
            return await axios({ method, url, data: JSON.stringify(data) });
        } catch (error) {
            this.httpError.handleHttpError(error);
            throw error;
        }
    }
}
